import styled, { css, gapSize, hoverFocus, rem, screenMobilePlusAndSmaller } from 'theme';
import borderRadius from 'theme/global/border-radius';
import boxShadow from 'theme/global/box-shadow';

export const Card = styled('div')`
  width: 100%;
  max-width: ${() => rem(512)};
  border-radius: ${borderRadius.base};
  box-shadow: ${boxShadow.section};
  background-color: var(--ref-color-blackwhite-white);
  margin: 0 auto;
  transform: translateY(${() => gapSize(-4)});
`;

export const PaymentOption = styled('button')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${() => gapSize(3)};

  background-color: var(--ref-color-blackwhite-white);
  width: 100%;
  height: ${() => rem(160)};
  border: var(--sys-border-width-sm) solid var(--ref-color-blackwhite-white);
  transition: 300ms ease-in-out;

  &:first-of-type {
    border-top-left-radius: ${borderRadius.base};
    border-top-right-radius: ${borderRadius.base};
    border-bottom: ${rem(1)} solid var(--ref-color-gray-20);
  }

  &:last-of-type {
    border-bottom-left-radius: ${borderRadius.base};
    border-bottom-right-radius: ${borderRadius.base};
  }

  ${() =>
    hoverFocus(css`
      cursor: pointer;
      background-color: var(--ref-color-gray-10);
      border-color: var(--ref-color-silver-60);
    `)}

  ${() =>
    screenMobilePlusAndSmaller(css`
      padding: 0 ${gapSize(2)};
      height: ${rem(140)};
    `)}
`;

export const PaymentOptionText = styled('div')`
  width: 100%;
  text-align: center;
`;

export const IconWrapper = styled('div')`
  min-width: ${() => rem(80)};
  text-align: center;
`;

const Iframe = styled('iframe')`
  border: none;
  height: 100%;
  width: 100%;
`;

export const IdealIframe = styled(Iframe)`
  min-height: ${() => rem(350)};
`;

export const CreditcardIframe = styled(Iframe)`
  height: ${rem(450)};
`;

export const IframeWrapper = styled('div')`
  padding: ${() => gapSize(2)};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${() => rem(16)};
  svg {
    height: ${() => rem(64)};
  }
`;

export const ErrorContainer = styled('div')`
  padding: ${() => gapSize(2)};
`;
